import Message from '@/Messages/Message';
import ComponentManager from '@/Management/ComponentManager';
import type DetailViewContext from '@/ViewModels/Contexts/DetailViewContext';

export default class DetailViewExitedMessage extends Message {

    public callId: string;
    public isServerError: boolean;
    public hasObjectChanged: boolean;
    public leavingAction: string;
    public hasPendingDVC: boolean;
    public isSummaryViewMode: boolean;
    public isOnStackNavigation: boolean;
    public isModalDetailView: boolean;

    /**
     * @override
     */
    public context: DetailViewContext;

    public constructor(params: any) {
        super(params);

        this.callId = this.paramOrDefault(params.callId, null);
        this.isServerError = this.paramOrDefault(params.isServerError, false);
        this.hasObjectChanged = this.paramOrDefault(params.hasObjectChanged, false);
        this.leavingAction = this.paramOrDefault(params.leavingAction, null);
        this.hasPendingDVC = this.paramOrDefault(params.hasPendingDVC, false);
        this.isSummaryViewMode = this.paramOrDefault(params.isSummaryViewMode, false);
        this.isOnStackNavigation = this.paramOrDefault(params.isOnStackNavigation, false);
        this.isModalDetailView = this.paramOrDefault(params.isModalDetailView, false);
    }

    public isCancelledOrSaved() {
        return this.leavingAction == 'Save' || this.leavingAction == 'Cancel';
    }
}

ComponentManager.setMessage('DetailViewExitedMessage', DetailViewExitedMessage, 'RADPresentation.HTMLClient.DefaultViewExtensions');